<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <v-col>
        <entrance-table-form />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <printer-table-form />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <device-table-form />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import EntranceTableForm from '@/components/forms/vms/EntranceTableForm';
import PrinterTableForm from '@/components/forms/vms/PrinterTableForm';
import DeviceTableForm from '@/components/forms/vms/DeviceTableForm';

export default {
  components: {
    EntranceTableForm,
    PrinterTableForm,
    DeviceTableForm,
  },
  props: {

  },
  data: () => ({

  }),
  computed: {
    ...mapState({

    }),
  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {

    },
  },
};
</script>
